import { lazy } from "react";
import ViewStudentNotification from "@repo/design-system/components/viewStudentNotification/ViewStudentNotification.jsx";

const Dashboard = lazy(() => import("../pages/dashboard/DashboardWrapper"));
// const AdminDashboard = lazy(() => import("../pages/dashboard/AdminDashboard"));
const ShiftConfiguration = lazy(() => import("../pages/shiftConfiguration/ShiftConfiguration"));
const ShiftScheduling = lazy(() => import("../pages/shiftScheduling/ShiftScheduling"));
const ShiftAssignment = lazy(() => import("../pages/shiftAssignment/ShiftAssignment"));
const AttendanceManagement = lazy(() => import("../pages/attendanceManagement/AttendanceManagement"));
const AttendanceRecord = lazy(() => import("../pages/attendanceManagement/feature/attendanceRecord/AttendanceRecord"));
const AttendanceReports = lazy(() => import("../pages/attendanceManagement/feature/attendanceReports/AttendanceReports"));
const DepartmentRecords = lazy(() => import("../pages/departmentRecords/DepartmentRecords"));
const Profile = lazy(() => import("../pages/profile/Profile"));
const Settings = lazy(() => import("@gyandiksha/profile/components/StudentSettings"));
const EditProfile = lazy(() => import("../pages/editProfile/EditProfile"));

// Leave Management Route
const LeaveRequests = lazy(() => import('../pages/leaveManagement/leaveRequests/LeaveRequests'));
const HolidayCalendar = lazy(() => import('../pages/leaveManagement/holidayCalendar/HolidayCalendar'));
const LeaveAllocation = lazy(() => import('../pages/leaveManagement/leaveAllocation/LeaveAllocation'));
const LeaveConfiguration = lazy(() => import('../pages/leaveManagement/leaveConfiguration/LeaveConfiguration'));
const DepartmentLeaveReport = lazy(() => import('../pages/leaveManagement/departmentLeaveReport/DepartmentLeaveReport'));

// Staff Self-Service (moved from staff-attendance app)
const StaffLeaveConfiguration = lazy(() => import('../pages/leaveConfiguration/LeaveConfiguration'));
const LeaveHistory = lazy(() => import('../pages/leaveHistory/LeaveHistory'));
const StaffAttendance = lazy(() => import('../pages/staffAttendance/StaffAttendance'));
const AttendanceHistory = lazy(() => import('../pages/attendanceHistory/AttendanceHistory'));
const MyShiftSchedule = lazy(() => import('../pages/shiftSchedule/MyShiftSchedule'));
const InstituteLocationManagement = lazy(() => import('../pages/instituteLocation/InstituteLocationManagement'));

const ViewStudentNotificationPage = () => (
    <ViewStudentNotification />
);

const ComponentNavigation = [
    {
        id: "dashboard", path: "/dashboard", exact: true, title: "Dashboard",
        component: Dashboard, hasParams: false, text: "Dashboard",
    },
    {
        id: "view-student-notification", path: "/view-student-notification", exact: true, title: "",
        component: ViewStudentNotificationPage, hasParams: false, text: "View Student Notifications",
    },
    // {
    //     id: "adminDashboard", path: "/admin-dashboard", exact: true, title: "Admin Dashboard",
    //     component: AdminDashboard, hasParams: false, text: "Admin Dashboard",
    // },

    // shift Management
    {
        id: "shiftSetup", path: "/shift-setup", exact: true, title: "Shift Setup",
        component: ShiftConfiguration, hasParams: false, text: "Shift Setup",
    },
    {
        id: "shiftAssignment", path: "/shift-assignment", exact: true, title: "Shift Assignment",
        component: ShiftAssignment, hasParams: false, text: "Shift Assignment",
    },
    {
        id: "shiftScheduling", path: "/shift-scheduling", exact: true, title: "Shift Scheduling",
        component: ShiftScheduling, hasParams: false, text: "Shift Scheduling",
    },

    // Attendance Management
    {
        id: "leaveApproval", path: "/leave-approval", exact: true, title: "Leave Approval",
        component: AttendanceManagement, hasParams: false, text: "Leave Approval",
    },
    {
        id: "attendanceRecord", path: "/attendance-record", exact: true, title: "Attendance Record",
        component: AttendanceRecord, hasParams: false, text: "Attendance Record",
    },
    {
        id: "attendanceReports", path: "/attendance-reports", exact: true, title: "Attendance Reports",
        component: AttendanceReports, hasParams: false, text: "Attendance Reports",
    },
    {
        id: "departmentAttendance", path: "/department-attendance", exact: true, title: "Department Attendance",
        component: DepartmentRecords, hasParams: false, text: "Department Attendance",
    },

    // Profile Management
    {
        id: "profile", path: "/profile", exact: true, title: "Profile",
        component: Profile, hasParams: false, text: "My Profile",
    },
    {
        id: "edit-profile", path: "/edit-profile", exact: true, title: "",
        component: EditProfile, hasParams: false, text: "Edit Profile",
    },
    {
        id: "settings", path: "/settings", exact: true, title: "Settings",
        component: Settings, hasParams: false, text: "Settings",
    },

    // Leave management route
    {
        id: "holidayCalendar", path: "/leave-management/holiday-calendar",
        exact: true, title: "Holiday Calendar", component: HolidayCalendar,
        hasParams: false, text: "Holiday Calendar",
    },
    {
        id: "leaveConfiguration", path: "/leave-management/leave-configuration",
        exact: true, title: "Leave Configuration", component: LeaveConfiguration,
        hasParams: false, text: "Leave Configuration",
    },
    {
        id: "leaveRequests", path: "/leave-management/leave-requests",
        exact: true, title: "Leave Requests", component: LeaveRequests,
        hasParams: false, text: "Leave Requests",
    },
    {
        id: "leaveAllocation", path: "/leave-management/leave-allocation",
        exact: true, title: "Leave Allocation", component: LeaveAllocation,
        hasParams: false, text: "Leave Allocation",
    },
    {
        id: "departmentLeaveReport", path: "/leave-management/department-leave-report",
        exact: true, title: "Department Leave Report", component: DepartmentLeaveReport,
        hasParams: false, text: "Department Leave Report",
    },

    // Staff Management
    {
        id: "staffLeaveConfiguration", path: "/staff-management/leave-configuration",
        exact: true, title: "Leave Configuration", component: StaffLeaveConfiguration,
        hasParams: false, text: "Leave Configuration",
    },
    {
        id: "leaveHistory", path: "/staff-management/leave-history",
        exact: true, title: "Leave History", component: LeaveHistory,
        hasParams: false, text: "Leave History",
    },
    {
        id: "attendanceHistory", path: "/staff-management/attendance-history",
        exact: true, title: "Attendance History", component: AttendanceHistory,
        hasParams: false, text: "Attendance History",
    },
    {
        id: "staffAttendance", path: "/staff-management/staff-attendance",
        exact: true, title: "Staff Attendance", component: StaffAttendance,
        hasParams: false, text: "Staff Attendance",
    },
    {
        id: "shiftSchedule", path: "/staff-management/shift-schedule",
        exact: true, title: "My Shift Scheduling", component: MyShiftSchedule,
        hasParams: false, text: "My Shift Scheduling",
    },

    // Institute Location Management
    {
        id: "instituteLocation", path: "/institute-location",
        exact: true, title: "Institute Location Management", component: InstituteLocationManagement,
        hasParams: false, text: "Institute Location Management",
    },

];

export default ComponentNavigation;
